<mat-toolbar>
  <nav class="w-100 d-flex justify-content-between align-items-center px-5">
    <img routerLink="/home" class="w-logo" src="assets/images/shared/logo-broadfactor.png" alt="Logo da Broadfactor">
    <ul class="d-none d-md-flex justify-content-between align-items-center mb-0">
      <li tabindex="0" routerLink="/home" (click)="goToSection('start')">Início</li>
      <li tabindex="0" ><a [href]="globalConfig.getBroadWebsite().aboutUs" target="_blank">Sobre</a> </li>
      <li tabindex="0" (click)="goToSection('how-it-works', 'home')">Como funciona</li>
      <li tabindex="0"><a [href]="globalConfig.getPlataformUrlList().loginUrl" target="_blank">Login</a></li>
      <li><a mat-flat-button class="bg-primary-dark-blue" [href]="globalConfig.getPlataformUrlList().supplierRegisterUrl" target="_blank">Faça seu cadastro</a></li>
    </ul>
    <button mat-icon-button aria-label="Botão de Menu" class="d-block d-md-none" [matMenuTriggerFor]="menu">
      <mat-icon>menu</mat-icon>
    </button>
  </nav>
</mat-toolbar>
<div class="header-height"></div>


<mat-menu #menu="matMenu">
  <a mat-menu-item routerLink="/home" (click)="goToSection('start')">Início</a>
  <a mat-menu-item [href]="globalConfig.getBroadWebsite().aboutUs" target="_blank">Sobre</a>
  <a mat-menu-item  (click)="goToSection('how-it-works', 'home')">Como funciona</a>
  <a mat-menu-item [href]="globalConfig.getPlataformUrlList().loginUrl" target="_blank">Login</a>
  <a mat-flat-button class="bg-primary-dark-blue m-2" [href]="globalConfig.getPlataformUrlList().supplierRegisterUrl" target="_blank">Faça seu cadastro</a>
</mat-menu>
